<section class="gallery-layout gallery-layout-12">
  @if (data().images; as images) {
    <div class="container">
      @if (images[0]; as image) {
        <app-image [image]="image" [size]="{ dh: 750, mh: 204, dw: 1200 }" />
      }
      @if (images[1]; as image) {
        <app-image
          [image]="image"
          [size]="{ dw: 282, dh: 352, mw: 96, mh: 120 }"
          class="image-forward"
          data-rellax-percentage="0.5"
          data-rellax-speed="-1"
          parallax />
      }
    </div>
  }
</section>
